module.exports = {"name":"Additional Privileges","release":"2018-09-18","__content":"<!--\n    This section contains the content of the log. You can use markdown here.\n\n    Please don't use heading markup as it clashes with the rest of the page.\n    If you absolutely HAVE to, please use #### Heading 4 or above.\n-->\n<ul>\n<li>Authorization is now required to access endpoints that return user data</li>\n<li>API endpoints returning Posts will now suppress userId inside Author for Anonymous calls</li>\n</ul>\n"}


//////////////////
// WEBPACK FOOTER
// ./src/changelog/logs/2018-09-18_Test.md
// module id = 666
// module chunks = 1